import React from "react";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import "./style.scss";

function Preklame() {
  useDocumentTitle("Pajak Reklame- BAPENDA BEKASI");
  return (
    <div className="page">
      <Header active="Preklame" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Jenis Pelayanan / Pajak Reklame" />
          <div className="page-title-wrapper">
            <div className="page-title">Pajak Reklame</div>
          </div>

          {/* <p className="page-text">
            Dalam rangka pelaksanaan Peraturan Pemerintah Nomor 18 Tahun 2016 tentang Perangkat Daerah dan Peraturan Menteri Dalam Negeri Nomor 97 Tahun 2016 tentang Perangkat Daerah Provinsi DKI Jakarta, maka berdasarkan Peraturan Gubernur
            Nomor 154 Tahun 2020 tentang Organisasi dan Tata Kerja Perangkat Daerah dibentuklah Badan Pendapatan Daerah (Bapenda) Provinsi DKI Jakarta.
          </p> */}

          <p className="subpage-title"><strong>Pajak Reklame</strong></p>
          <p className="page-text"> Reklame adalah benda, alat, perbuatan, atau media yang bentuk dan corak
ragamnya dirancang untuk tujuan komersial memperkenalkan,
menganjurkan, mempromosikan, atau menarik perhatian umum terhadap
sesuatu.
</p>
<p className="page-text"><strong>Objek Pajak Reklame meliputi: </strong><br></br>
a. Reklame papan/billboard/videotron/megatron;<br></br>
b. Reklame kain;<br></br>
c. Reklame melekat/stiker;<br></br>
d. Reklame selebaran;<br></br>
e. Reklame berjalan, termasuk pada kendaraan;<br></br>
f. Reklame udara;<br></br>
g. Reklame apung;<br></br>
h. Reklame film/slide; dan<br></br>
i. Reklame peragaan.
<br></br>
<p className="page-text"><strong>Dasar pengenaan Pajak Reklame: </strong><br></br>
1. Dasar pengenaan Pajak Reklame adalah nilai sewa Reklame.<br></br>
2. Dalam hal Reklame diselenggarakan oleh pihak ketiga, nilai sewa Reklame ditetapkan berdasarkan nilai kontrak
Reklame.<br></br>
3. Dalam hal Reklame diselenggarakan sendiri, nilai sewa Reklame dihitung dengan memperhatikan
faktor jenis, bahan yang digunakan, lokasi penempatan, waktu
penayangan, jangka waktu penyelenggaraan, jumlah, dan ukuran media
Reklame.<br></br>
4. Dalam hal nilai sewa Reklame tidak diketahui dan/atau dianggap tidak
wajar, nilai sewa Reklame ditetapkan dengan menggunakan faktor dalam point 3.<br></br>
5. Perhitungan nilai sewa Reklame ditetapkan dengan Peraturan Wali Kota.
</p>
<p className="page-text"><strong>Tarif Pajak Reklame ditetapkan sebesar 25% (dua puluh lima persen). </strong>

</p>
<br></br>
<p className="page-text"><strong>
DASAR HUKUM : </strong><br></br>
<a href="https://jdih.bekasikota.go.id/peraturan-daerah/view?id=525" target="_blank" rel="noreferrer"><font color="blue">Peraturan Daerah Kota Bekasi Nomor 1 Tahun 2024 Tentang Pajak Daerah Dan Retribusi Daerah</font></a>
</p>

</p>

         
        
         
         
          
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default Preklame;
